import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { language } = useLanguage();

  const getLocalizedText = (texts) => texts[language] || texts.tc;

  return (
    <footer className="bg-gradient-to-br from-emerald-800 to-teal-700 text-white py-16" data-testid="main-footer">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-4 text-white" data-testid="footer-brand">
              {language === 'tc' ? '樹記海鮮' : language === 'cn' ? '树记海鲜' : 'SHUKEE SEAFOOD'}
            </h3>
            <p className="text-emerald-100 leading-relaxed mb-6">
              {language === 'tc' 
                ? '從海洋到餐桌，致力於提供最高標準的專業服務。'
                : language === 'cn'
                ? '从海洋到餐桌，致力于提供最高标准的专业服务。'
                : 'From sea to table, committed to providing the highest standards of professional service.'}
            </p>
            <div className="grid grid-cols-2 gap-4 max-w-xs">
              <a 
                href="https://www.premierfresh.com.hk/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block hover:opacity-80 transition-opacity"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_seafood-cms/artifacts/pl8erne1_logo_01.jpeg" 
                  alt="Premier Fresh" 
                  className="h-20 w-auto bg-white rounded-lg p-2"
                />
              </a>
              <img 
                src="https://customer-assets.emergentagent.com/job_freshcatch-5/artifacts/o74txndn_logo_02.jpeg" 
                alt="Caring Company" 
                className="h-20 w-auto bg-white rounded-lg p-2"
              />
              <a 
                href="https://shukee.com.hk" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block hover:opacity-80 transition-opacity"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_freshcatch-5/artifacts/7lyivk03_logo_03.jpeg" 
                  alt="Shukee Seafood" 
                  className="h-20 w-auto bg-white rounded-lg p-2"
                />
              </a>
              <img 
                src="https://customer-assets.emergentagent.com/job_freshcatch-5/artifacts/cjqfpq7n_logo_04.jpeg" 
                alt="Award" 
                className="h-20 w-auto bg-white rounded-lg p-2"
              />
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">
              {language === 'tc' ? '快速連結' : language === 'cn' ? '快速连结' : 'Quick Links'}
            </h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-emerald-100 hover:text-white transition-colors">
                {language === 'tc' ? '我們的故事' : language === 'cn' ? '我们的故事' : 'Our Story'}
              </Link>
              <Link to="/products" className="block text-emerald-100 hover:text-white transition-colors">
                {language === 'tc' ? '我們的海鮮' : language === 'cn' ? '我们的海鲜' : 'Our Seafood'}
              </Link>
              <Link to="/awards" className="block text-emerald-100 hover:text-white transition-colors">
                {language === 'tc' ? '為何選我們' : language === 'cn' ? '为何选我们' : 'Why Choose Us'}
              </Link>
              <Link to="/blog" className="block text-emerald-100 hover:text-white transition-colors">
                {language === 'tc' ? '最新動態' : language === 'cn' ? '最新动态' : 'Latest News'}
              </Link>
              <Link to="/contact" className="block text-emerald-100 hover:text-white transition-colors">
                {language === 'tc' ? '與我們聯絡' : language === 'cn' ? '与我们联络' : 'Contact Us'}
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">
              {language === 'tc' ? '聯絡資訊' : language === 'cn' ? '联络资讯' : 'Contact Info'}
            </h4>
            <div className="space-y-2 text-emerald-100">
              <p>📞 2543-9248 / 2543-9249</p>
              <p>📠 2543-0261</p>
              <a 
                href="https://wa.me/85298605400" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block hover:text-white transition-colors"
              >
                💬 WhatsApp {language === 'tc' ? '聯絡' : language === 'cn' ? '联络' : 'Contact'}
              </a>
              <p>✉️ info@shukee.com.hk</p>
            </div>
          </div>
        </div>

        <div className="border-t border-emerald-600 mt-12 pt-8 text-center text-emerald-100">
          <p>&copy; 2026 Shukee Seafood Company Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;